<ax-value-edit
  type="DATE"
  [form]="dateControl"
  [name]="name"
  [autofocus]="autofocus"
  [label]="label"
  [hint]="hint"
  [required]="required"
  [icon]="showIcon ? (customIcon ? customIcon : 'calendar') : undefined"
  [errorsTemplate]="errorsTemplate"
  [readonly]="readonly"
  [subscriptSizing]="subscriptSizing"
></ax-value-edit>

<ng-template #errorsTemplate>
  <ax-property-error [form]="form" [label]="label"></ax-property-error>
</ng-template>
